<template>
	<div class="mt-12 yx-form-wrap">
		<el-form :inline="true" :model="formData" label-width="100px">
			<el-form-item label="二级团长昵称">
				<el-input v-model="formData['applyInstitutionName']" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item label="团长活动">
				<el-input v-model="formData['applyActivityName']" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item label="团长活动ID">
				<el-input v-model="formData['applyActivityId']" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item label="提报时间">
				<el-date-picker
					:default-time="['00:00:00', '23:59:59']"
					@change="value => changeTimed(value)"
					class="data-picker"
					v-model="time"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:picker-options="pickerOptions"
				></el-date-picker>
			</el-form-item>
			<el-form-item label="是否自动提报">
				<el-select v-model="formData['applyType']">
					<el-option label="全部" value=""></el-option>
					<el-option label="是" value="2"></el-option>
					<el-option label="否" value="1"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit">筛选</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';

export default {
	name: 'search',
	props: {},
	computed: {},
	data() {
		return {
			formData: {},
			time: [],
			pickerOptions: {
				disabledDate(time) {
					// 1. 获取当前时间
					const now = new Date();
					
					// 2. 获取今天结束的时间点（今天的 23:59:59）
					// setHours(23, 59, 59, 999) 设置为当天的最后一毫秒
					const endOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
					
					// 3. 如果时间大于今天的结束时间，则禁用
					return time.getTime() > endOfToday.getTime();
				}
			}
		};
	},
	methods: {
		onClear() {
			this.formData = {};
			this.time = []
			this.onSubmit();
		},
		changeTimed(value) {
			const [start, end] = value || [];
			this.formData.applyTimeStart = start ? Math.floor(new Date(start).getTime() / 1000) : '';
			this.formData.applyTimeEnd = end ? Math.floor(new Date(end).getTime() / 1000) : '';
		},
		onSubmit: throttle(function () {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
};
</script>

<style lang="less" scoped></style>
